import { observable, computed,action } from 'mobx';

// API Calls
import axios from 'axios';
let api = axios.create({ baseURL: 'https://online.gpbook.com.au/api/' });

if (process.env.NODE_ENV === 'development') {
    api = axios.create({ baseURL: 'http://localhost:3080/api/' });
}

if (location.hostname==="adrian.gpbook.com.au") {
	api = axios.create({ baseURL: 'http://adrian.gpbook.com.au/api/' });
}

import initDoctor from './initDoctor'
import initSteps from './initSteps'

// class
class AppStore {

	api = api

	@observable initDoctor = {}
	@observable doctor = {}
	@observable username = ""
	@observable password = ""

	@observable purchase = {
		bookQuantity: 0,
		onlineQuantity: 0,
		psychQuantity: 0,
		combineQuantity: 0,
		organisation: '',
		checkAllInputsFilled: false,
		organisationOther: "",
		contactName: "",
		name: "",
		phone: "",
		fax: "",
		email: "",
		website: "",
		address: "",
		deliveryAddress: "",
		address_line1: "",
		address_line2: "",
		address_city: "",
		address_state: "WA",
		address_country: "Australia",
		address_zip: "",

		// Return from stripe
		customer_id: "",
		
	}

	@observable step = 0
	@observable lastCompletedStep = 0
	
	@observable steps = initSteps
	
	@action prevStep = () => {
		
	}

	@action nextStep = () => {
		this.steps[this.step].status = 'finish'
		this.lastCompletedStep = this.step + 1
	}

	@action addBook = ({ target })=> {
		if (target.value < 0) {
			this.purchase.bookQuantity = 0
		} else {
			this.purchase.bookQuantity = parseInt(target.value,10)
		}
	}

	@action addOnline = ({ target }) => {
		if (target.value < 0) {
			this.purchase.onlineQuantity = 0
		} else {
			this.purchase.onlineQuantity = parseInt(target.value,10)
		}
	}

	@action addPsych = ({ target }) => {
		if (target.value < 0) {
			this.purchase.psychQuantity = 0
		} else {
			this.purchase.psychQuantity = parseInt(target.value,10)
		}
	}

	// @action addCombine = ({ target }) => {
	// 	if (target.value < 0) {
	// 		this.purchase.combineQuantity = 0
	// 	} else {
	// 		this.purchase.combineQuantity = parseInt(target.value,10)
	// 	}
	// }

	@computed get bookPrice() {
		const { bookQuantity } = this.purchase
		const gp = this.purchase.organisation === "General Practice" ? true : false
		if (bookQuantity) {

			// GP
			if (gp) {
				if (bookQuantity < 5) {
					return (bookQuantity * 66)
				}
				if (bookQuantity > 4 && bookQuantity < 20) {
					return (bookQuantity * 60)
				}
				if (bookQuantity > 19) {
					return (bookQuantity * 60)
				}
			} else {
				
			// Non-GP
				if (bookQuantity < 5) {
					return (bookQuantity * 92)
				}
				if (bookQuantity > 4 && bookQuantity < 20) {
					return (bookQuantity * 86)
				}
				if (bookQuantity > 19) {
					return (bookQuantity * 86)
				}
			}
		} else {
			return (0)
		}
	}

	@computed get psychPrice() {
		// if (this.purchase.psychQuantity === 1) {
		// 	return 0 * this.purchase.psychQuantity
		// }
		// if (this.purchase.psychQuantity > 1) {
		// 	return 25 * (this.purchase.psychQuantity - 1)
		// }
		// return 0

		// No longer free for first edition
		return 25 * this.purchase.psychQuantity
	}

	@computed get onlinePrice() {
		// =IF(C2=0,0,IF(C2=1,3.8,IF(C2>1,3.8+2.8*(C2-1))))

		const { onlineQuantity } = this.purchase
		const gp = this.purchase.organisation === "General Practice" ? true : false
		if (onlineQuantity) {

			// GP
			if (gp) {
				return (onlineQuantity * 4 * 12)
				// if (onlineQuantity === 1) {
				// 	return (onlineQuantity * 3.8)
				// }
				// if (onlineQuantity > 1) {
				// 	return ((1 * 3.8) + ((onlineQuantity-1) * 2.8))
				// }
				
			} else {
				
			// Non-GP
				return (onlineQuantity * 6 * 12)
				// if (onlineQuantity === 1) {
				// 	return (onlineQuantity * 6)
				// }
				// if (onlineQuantity > 1) {
				// 	return ((1 * 6) + ((onlineQuantity-1) * 5))
				// }
			}
		} else {
			return (0)
		}


		if (this.purchase.onlineQuantity) {
			return (this.purchase.onlineQuantity * 4 * 12)
			// return (this.purchase.onlineQuantity * 3.8)
		} else {
			return (0)
		}
	}

	@computed get totalPrice() {
		return this.bookPrice+this.psychPrice
		// return this.bookPrice+this.combineBookPrice
	}

	@computed get totalSubPrice() {
		return this.onlinePrice+this.combineOnlinePrice
	}

	@computed get bookUnitPrice() {
		const { bookQuantity } = this.purchase
		const gp = this.purchase.organisation === "General Practice" ? true : false
		// GP
		if (gp) {
			if (bookQuantity < 5) {
				return 66
			}
			if (bookQuantity > 4 && bookQuantity < 20) {
				return 60
			}
			if (bookQuantity > 19) {
				return 60
			}
		} else {
			
		// Non-GP
			if (bookQuantity < 5) {
				return 92
			}
			if (bookQuantity > 4 && bookQuantity < 20) {
				return 86
			}
			if (bookQuantity > 19) {
				return 86
			}
		}
	}

	@computed get combineBookPrice() {
		const { combineQuantity } = this.purchase
		const gp = this.purchase.organisation === "General Practice" ? true : false
		if (combineQuantity) {
			// GP
			if (gp) {
				// Cost of Book
				let bookCost = 0
				if (combineQuantity < 5) {
					bookCost = (combineQuantity * 66)
				}
				if (combineQuantity > 4 && combineQuantity < 20) {
					bookCost = (combineQuantity * 60)
				}
				if (combineQuantity > 19) {
					bookCost = (combineQuantity * 60)
				}
				// Discounted 
				const tenPercent = bookCost  * 0.1
				// Apply discount
				const totalPrice = bookCost - tenPercent
				// Return fixed
				return totalPrice
			} else {
			// Non-GP
				// Cost of Book
				let bookCost = 0
				if (combineQuantity < 5) {
					bookCost = (combineQuantity * 92)
				}
				if (combineQuantity > 4 && combineQuantity < 20) {
					bookCost = (combineQuantity * 86)
				}
				if (combineQuantity > 19) {
					bookCost = (combineQuantity * 86)
				}
				// Discounted 
				const tenPercent = bookCost * 0.1
				// Apply discount
				const totalPrice = bookCost - tenPercent
				// Return fixed
				return totalPrice
			}
		} else {
			return (0)
		}
	}

	@computed get combineOnlinePrice() {
		// =IF(C2=0,0,IF(C2=1,3.8,IF(C2>1,3.8+2.8*(C2-1))))

		const { combineQuantity } = this.purchase
		const gp = this.purchase.organisation === "General Practice" ? true : false
		if (combineQuantity) {

			// GP
			if (gp) {

				// Cost of Online
				let onlineCost = 0
				if (combineQuantity === 1) {
					onlineCost = (combineQuantity * 3.8)
				}
				if (combineQuantity > 1) {
					onlineCost = ((1 * 3.8) + ((combineQuantity-1) * 2.8))
				}
				// Over 12 months
				onlineCost *= 12 

				// Discounted 
				const tenPercent = onlineCost * 0.1

				// Apply discount
				const totalPrice = onlineCost - tenPercent

				// Return fixed
				return totalPrice
				
			} else {
				
				// Non-GP
				// Cost of Online
				let onlineCost = 0
				if (combineQuantity === 1) {
					onlineCost = (combineQuantity * 6)
				}
				if (combineQuantity > 1) {
					onlineCost = ((1 * 6) + ((combineQuantity-1) * 5))
				}
				// Over 12 months
				onlineCost *= 12

				// Discounted 
				const tenPercent = onlineCost * 0.1

				// Apply discount
				const totalPrice = onlineCost - tenPercent

				// Return fixed
				return totalPrice
			}
		} else {
			return (0)
		}
	}

	@computed get combinePrice() {
		return this.combineOnlinePrice + this.combineBookPrice + this.psychPrice
		// return this.combineOnlinePrice + this.combineBookPrice
	}

	@computed get combinePriceDiscount() {
		// return this.combinePrice * 0.1
		return ((this.combinePrice / 0.9 ) - this.combinePrice )
	}

	constructor() {
		this.init()
	}

	clearDoctor = () => {
		// Set Profile from Cache
		localStorage.removeItem("update_doctor")
		this.doctor = {...initDoctor}
		this.initDoctor = {...initDoctor}
	}

	init = () => {
		// Set Profile from Cache
		const doctor = localStorage.getItem("update_doctor")
		const username = localStorage.getItem("update_username")
		const password = localStorage.getItem("update_password")
		const purchase = localStorage.getItem("purchase")
		
		if (doctor) {
			this.doctor = JSON.parse(doctor)
			this.initDoctor = JSON.parse(doctor)
		} else {
			this.doctor = initDoctor
			this.initDoctor = initDoctor
		}
		if (username) {
			this.username = JSON.parse(username)
		}
		if (password) {
			this.password = JSON.parse(password)
		}
		if (purchase) {
			this.purchase = JSON.parse(purchase)
		}

	}
	submitUpdate = () => {
		return this.api.post('/update/submit', { hodby_id: this.username, hodby_password: this.password, doctorUpdates: this.doctor })
			.then(({data}) => {
				console.log(data)
				return true
			})
			.catch(err => {
				console.log(err)
				return false
			})
	}
	submitNewListing = () => {
		return this.api.post('/update/submit/new', { doctorUpdates: this.doctor })
		.then(({data}) => {
			console.log(data)
			this.clearDoctor()
			return true
		})
		.catch(err => {
			console.log(err)
			return false
		})
	}
	
}

export default AppStore


// WEBPACK FOOTER //
// ./src/Containers/store/store.js